import { Form } from "antd";
import { HeaderOverview } from "components";
import {
  ErrorDashboard,
  LoadingDashboard,
  Wrapper,
  checkDataObject,
} from "pages/overview";
import { useOverview } from "providers/overview";
import { useTranslation } from "react-i18next";
import { useGetDashboardWeb } from "service/dashboard/central/overview";
import { SpaceStyle } from "..";

const BackOffice = () => {
  const { t } = useTranslation();
  const { findDate, property } = useOverview();
  const backOfficeDate = Form.useWatch("backOfficeDate");
  const date = findDate(backOfficeDate, "month");

  const { data, isFetching, isError, error } = useGetDashboardWeb({
    property,
    ...date,
  });

  const countBackOffice = data ? checkDataObject(data) : "0";

  return (
    <Wrapper className="h-[300px]">
      <LoadingDashboard loading={isFetching}>
        <HeaderOverview
          title={t("number-of-user-using-back-office")}
          name="backOfficeDate"
        />
        {isError ? (
          <ErrorDashboard error={error} height="200px" />
        ) : (
          <SpaceStyle className="center " direction="vertical">
            <div className="count " style={{fontSize:"36px"}} >{`${countBackOffice}`}</div>
            <div className="people " style={{fontSize:"24px"}}>{t("people")}</div>
          </SpaceStyle>
        )}
      </LoadingDashboard>
    </Wrapper>
  );
};

export default BackOffice;
